import React from "react";
import "./layout.css";
import Header from "./Header/index";
import GlobalStyle from "../styles/global.css";

import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import defaultShareImg from "../images/share.jpg";

const Layout = (props) => {
  const { site } = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
          url
          author
          domain
        }
      }
    }
  `);

  const { title, description, url, author, domain } = site.siteMetadata;

  return (
    <>
      <Helmet>
        <html lang="es" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={`${domain}${defaultShareImg}`} />
        <meta property="twitter:card" content={`summary_large_image`} />
        <meta property="twitter:creator" content={author} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta
          property="twitter:image"
          content={`${domain}${defaultShareImg}`}
        />
      </Helmet>
      <GlobalStyle />
      <Header />

      {props.children}
    </>
  );
};

export default Layout;
